// Section 16: Merciful justice norm. Established by pardons and restitution (4 uses in a row;
// reset by flogging, exile or execution; imprisonment is neutral); lost after 8 seasons without
// reinforcement. Effect once established: crime baseline 1.2x; trust recovery 1.3x (the positive
// trust causes in config.trust.recoveryCauses).
// Constants: config.normRules, config.norms['merciful-justice'].
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { defineNorm } from '../../core/registry';

const LENIENT: readonly string[] = ['pardon', 'restitution'];
const HARSH: readonly string[] = ['flogging', 'exile', 'execution'];

export function mercifulJustice(config: Config) {
  const c = config.norms['merciful-justice'];

  return defineNorm({
    id: 'merciful-justice',
    label: 'Merciful justice',
    section: 'S16',
    establishAfter: config.normRules.establishAfter,
    decayAfter: config.normRules.decayAfter,
    reinforcedBy: (_ctx, entry) => entry.kind === 'justice' && LENIENT.includes(entry.response),
    contradictedBy: (_ctx, entry) => entry.kind === 'justice' && HARSH.includes(entry.response),
    modifierTargets: ['crimeRisk', 'trustChange'],
    modifierKeys: { trustChange: config.trust.recoveryCauses },
    modifiers(ctx, target) {
      if (!ctx.state.norms['merciful-justice'].established) return [];
      if (target.kind === 'crimeRisk')
        return [mod.mul('norm:merciful-justice', c.crimeMul, 'merciful justice')];
      if (target.kind === 'trustChange' && config.trust.recoveryCauses.includes(target.cause))
        return [mod.mul('norm:merciful-justice', c.trustRecoveryMul, 'trust recovers faster')];
      return [];
    },
  });
}
